import { UUID } from '@benzinga/session';
import { WatchlistHoldingsFeed } from './feed';

export class WatchlistHoldingsStore {
  private watchlistsFeeds: WatchlistHoldingsFeed[] = [];

  public addFeed = (feed: WatchlistHoldingsFeed) => this.watchlistsFeeds.push(feed);

  public getFeed = (watchlistId: UUID): WatchlistHoldingsFeed | undefined =>
    this.watchlistsFeeds.find(f => f.getWatchlistId() === watchlistId);
}
